/* YIPS MOBILE MENU V7 - Oct 30 2026 */
(function(){
  function init(root){
    if(root.__ym) return; root.__ym=true;
    var btn=root.querySelector('[data-ym-toggle]'), panel=root.querySelector('[data-ym-panel]'), back=root.querySelector('[data-ym-backdrop]');
    if(!btn||!panel) return;
    var header=root.closest('header')||document.querySelector('.yips-header');
    var open=false, timer=null;
    function setTop(){ var r=header?header.getBoundingClientRect():{bottom:0}; root.style.setProperty('--ym-top',Math.max(0,Math.round(r.bottom))+'px'); }
    function focusables(){ return [btn].concat([].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])')).filter(function(el){return el.offsetParent!==null;})); }
    function show(){
      if(open) return; open=true; clearTimeout(timer);
      warm(); setTop(); panel.hidden=false; back.hidden=false;
      document.documentElement.classList.add('ym-lock');
      btn.setAttribute('aria-expanded','true'); btn.setAttribute('aria-label','Close menu');
      panel.offsetHeight; // reflow so the transition runs
      requestAnimationFrame(function(){ setTop(); panel.classList.add('is-open'); back.classList.add('is-open'); });
      panel.focus({preventScroll:true});
      document.addEventListener('keydown',onKey);
    }
    function hide(returnFocus){
      if(!open) return; open=false;
      panel.classList.remove('is-open'); back.classList.remove('is-open');
      btn.setAttribute('aria-expanded','false'); btn.setAttribute('aria-label','Open menu');
      document.documentElement.classList.remove('ym-lock');
      document.removeEventListener('keydown',onKey);
      timer=setTimeout(function(){ if(!open){ panel.hidden=true; back.hidden=true; } },380);
      if(returnFocus!==false) btn.focus({preventScroll:true});
    }
    function onKey(e){
      if(e.key==='Escape'){ e.preventDefault(); hide(); return; }
      if(e.key==='Tab'){
        var f=focusables(); if(!f.length) return;
        var first=f[0], last=f[f.length-1], a=document.activeElement;
        if(e.shiftKey && (a===first||a===panel)){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && a===last){ e.preventDefault(); first.focus(); }
      }
    }
    function warm(){ [].forEach.call(panel.querySelectorAll('img[loading=lazy]'),function(i){ i.loading='eager'; }); }
    btn.addEventListener('pointerdown',warm,{once:true}); btn.addEventListener('focus',warm,{once:true});
    btn.addEventListener('click',function(e){ e.preventDefault(); open?hide():show(); });
    back.addEventListener('click',function(){ hide(); });
    panel.addEventListener('click',function(e){ var a=e.target.closest('a[href]'); if(a) hide(false); });
    window.addEventListener('resize',function(){ if(!open) return; if(window.innerWidth>=1100) hide(false); else setTop(); });
    window.addEventListener('pageshow',function(){ if(open) hide(false); });

    /* predictive search */
    var input=root.querySelector('[data-ym-input]'), box=root.querySelector('[data-ym-results]');
    var url=(root.getAttribute('data-suggest-url')||'/search/suggest')+'.json', deb=null, seq=0;
    function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
    function money(p){ var n=parseFloat(p); if(isNaN(n)) return ''; return '$'+(n%1?n.toFixed(2):n.toFixed(0)); }
    if(input&&box){
      input.addEventListener('input',function(){
        clearTimeout(deb); var q=input.value.trim();
        if(q.length<2){ box.hidden=true; box.innerHTML=''; return; }
        deb=setTimeout(function(){
          var my=++seq;
          fetch(url+'?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last',{headers:{Accept:'application/json'}})
            .then(function(r){return r.json();}).then(function(d){
              if(my!==seq) return;
              var ps=(d&&d.resources&&d.resources.results&&d.resources.results.products)||[];
              var all=(root.querySelector('.ym-search').getAttribute('action')||'/search')+'?type=product&q='+encodeURIComponent(q);
              if(!ps.length){ box.innerHTML='<div class="ym-results__empty">No hats match “'+esc(q)+'”. Try another word.</div>'; }
              else box.innerHTML=ps.map(function(p){
                var img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
                if(img) img+=(img.indexOf('?')>-1?'&':'?')+'width=120';
                return '<a href="'+esc(p.url)+'">'+(img?'<img src="'+esc(img)+'" alt="" width="46" height="46" loading="lazy">':'')+'<span class="ym-results__t">'+esc(p.title)+'</span><span class="ym-results__p">'+money(p.price)+'</span></a>';
              }).join('')+'<a class="ym-results__all" href="'+esc(all)+'">See all results</a>';
              box.hidden=false;
            }).catch(function(){ box.hidden=true; });
        },180);
      });
    }
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-yips-menu]'),init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
